module.exports = __webpack_public_path__ + "img/TSC_kwania.512b01c6.jpg";